// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-selling-confirmation .modal-main {
  padding: 0;
  max-width: 500px;
}
.product-selling-confirmation .effective-date-wrap .suggested-effective-date-wrap {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  padding-bottom: 10px;
  display: flex;
  gap: 10px;
  padding-top: 10px;
}
.product-selling-confirmation .effective-date-wrap .suggested-effective-date-label {
  font-weight: 500;
}
.product-selling-confirmation .effective-date-wrap .effective-date-value {
  margin-block: 10px;
}
.product-selling-confirmation .modal-header {
  display: flex;
  align-items: center;
  margin: 0;
  padding-block: 20px 17px;
  margin-inline: 14px 19px;
  justify-content: center;
  border-bottom: 2px solid #D2D2D2;
}
.product-selling-confirmation .modal-header .modal-close-btn {
  width: 21px;
  height: 17px;
  color: #000;
  top: 22px;
}
.product-selling-confirmation .modal-heading-main {
  color: #333;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 111.111% */
  letter-spacing: 0.18px;
}
.product-selling-confirmation .product-name-price-wrap {
  display: flex;
  gap: 40px;
  padding-inline: 53px;
  padding-block: 41px;
  justify-content: space-between;
}
.product-selling-confirmation .product-name-price-wrap input::-webkit-inner-spin-button {
  display: none;
}
.product-selling-confirmation .product-name-price-wrap mat-form-field span.mat-prefix {
  width: 38px;
  height: 44px;
  display: flex;
  align-items: center;
  border-radius: 5px 0px 0px 5px;
  border-right: 1px solid #D2D2D2;
  background: #EDEDED;
  justify-content: center;
  margin-right: 4px;
}
.product-selling-confirmation .product-name-price-wrap:has(+ .effective-date-wrap) {
  padding-bottom: 20px;
}
.product-selling-confirmation .effective-date-wrap {
  padding-inline: 53px;
  padding-bottom: 20px;
}
.product-selling-confirmation .product-price-value {
  color: #797D82;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.product-selling-confirmation .product-name-value {
  color: #000;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.product-selling-confirmation .product-name-title,
.product-selling-confirmation .product-price-title {
  color: #4C5258;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
  padding-bottom: 16px;
}
.product-selling-confirmation .submit-btn-wrap {
  border-radius: 4px;
  background: #6ECB44;
  margin-inline: -3px;
  margin-bottom: -3px;
}
.product-selling-confirmation .submit-btn-wrap button {
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  padding-block: 13px;
  width: 100%;
}

.product-selling-confirmation .effective-wrap mat-icon.date-clear-btn {
  opacity: 0.7;
  cursor: pointer;
  display: inline-block;
}

.date-clear-btn {
  margin-right: 11px;
  position: relative;
  cursor: pointer;
}

@media screen and (max-width: 590px) {
  .product-selling-confirmation .modal-main {
    padding: 0;
    max-width: 460px;
  }
}
@media screen and (max-width: 492px) {
  .product-selling-confirmation .modal-main {
    padding: 0;
    max-width: 340px;
  }
  .product-selling-confirmation .product-name-price-wrap {
    display: flex;
    gap: 20px;
    padding-inline: 23px;
    padding-block: 21px;
    flex-direction: column;
  }
  .product-selling-confirmation .effective-date-wrap {
    padding-inline: 23px;
    padding-bottom: 20px;
  }
  .product-selling-confirmation .product-name-title,
  .product-selling-confirmation .product-price-title {
    padding-bottom: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/product-selling-confirmation/product-selling-confirmation.component.scss"],"names":[],"mappings":"AACI;EACI,UAAA;EACA,gBAAA;AAAR;AAGQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AADZ;AAGQ;EACI,gBAAA;AADZ;AAGQ;EACI,kBAAA;AADZ;AAII;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,gCAAA;AAFR;AAGQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AADZ;AAII;EACI,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAFR;AAII;EACI,aAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;AAFR;AAGQ;EACI,aAAA;AADZ;AAGQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AADZ;AAII;EACI,oBAAA;AAFR;AAII;EACI,oBAAA;EACA,oBAAA;AAFR;AAII;EACI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFR;AAII;EACI,WAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFR;AAII;;EAGI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAHR;AAKI;EAEI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAJR;AAMQ;EACI,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAJZ;;AAUQ;EACI,YAAA;EACA,eAAA;EACA,qBAAA;AAPZ;;AAWA;EACI,kBAAA;EACA,kBAAA;EAEA,eAAA;AATJ;;AAYA;EAGQ;IACI,UAAA;IACA,gBAAA;EAXV;AACF;AAeA;EAGQ;IACI,UAAA;IACA,gBAAA;EAfV;EAiBM;IACI,aAAA;IACA,SAAA;IACA,oBAAA;IACA,mBAAA;IACA,sBAAA;EAfV;EAiBM;IACI,oBAAA;IACA,oBAAA;EAfV;EAiBM;;IAEI,oBAAA;EAfV;AACF","sourcesContent":[".product-selling-confirmation{\n    .modal-main{\n        padding: 0;\n        max-width: 500px;\n    }\n    .effective-date-wrap{\n        .suggested-effective-date-wrap {\n            font-family:  var(--font-family);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 17px;\n            padding-bottom: 10px;\n            display: flex;\n            gap: 10px;\n            padding-top: 10px;\n        }\n        .suggested-effective-date-label {\n            font-weight: 500;\n        }\n        .effective-date-value {\n            margin-block: 10px;\n        }\n    }\n    .modal-header {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        padding-block: 20px  17px ;\n        margin-inline:  14px 19px;\n        justify-content: center;\n        border-bottom: 2px solid #D2D2D2;\n        .modal-close-btn{\n            width: 21px;\n            height: 17px;\n            color: #000;\n            top: 22px;\n        }\n    }\n    .modal-heading-main{\n        color: #333;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px; /* 111.111% */\n        letter-spacing: 0.18px;\n    }\n    .product-name-price-wrap {\n        display: flex;\n        gap: 40px;\n        padding-inline: 53px;\n        padding-block: 41px;\n        justify-content: space-between;\n        input::-webkit-inner-spin-button{\n            display: none;\n        }\n        mat-form-field span.mat-prefix {\n            width: 38px;\n            height: 44px;\n            display: flex;\n            align-items: center;\n            border-radius: 5px 0px 0px 5px;\n            border-right: 1px solid #D2D2D2;\n            background: #EDEDED;\n            justify-content: center;\n            margin-right: 4px;\n        }\n    }\n    .product-name-price-wrap:has( + .effective-date-wrap){\n        padding-bottom: 20px;\n    }\n    .effective-date-wrap {\n        padding-inline: 53px;\n        padding-bottom: 20px;\n    }\n    .product-price-value {\n        color: #797D82;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 18px;\n    }\n    .product-name-value {\n        color: #000;\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    .product-name-title,\n    .product-price-title\n    {\n        color: #4C5258;\n        font-family:  var(--font-family);\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 10px;\n        padding-bottom: 16px;\n    }\n    .submit-btn-wrap {\n        \n        border-radius: 4px;\n        background: #6ECB44;\n        margin-inline: -3px;\n        margin-bottom: -3px;\n\n        button{\n            color: #FFF;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n            letter-spacing: 0.7px;\n            text-transform: uppercase;\n            padding-block: 13px;\n            width: 100%;\n        }\n    }\n}\n.product-selling-confirmation{\n    .effective-wrap{\n        mat-icon.date-clear-btn {\n            opacity: 0.7;\n            cursor: pointer;\n            display: inline-block;\n        }\n    }\n}\n.date-clear-btn {\n    margin-right: 11px;\n    position: relative;\n    // top: 4px;\n    cursor: pointer;\n}\n\n@media screen  and (max-width: 590px){\n    \n    .product-selling-confirmation{\n        .modal-main{\n            padding: 0;\n            max-width: 460px;\n        }\n        \n    }\n}\n@media screen  and (max-width: 492px){\n    \n    .product-selling-confirmation{\n        .modal-main{\n            padding: 0;\n            max-width: 340px;\n        }\n        .product-name-price-wrap {\n            display: flex;\n            gap: 20px;\n            padding-inline: 23px;\n            padding-block: 21px;\n            flex-direction: column;\n        }\n        .effective-date-wrap {\n            padding-inline: 23px;\n            padding-bottom: 20px;\n        }\n        .product-name-title,\n        .product-price-title{\n            padding-bottom: 12px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
